import { render, staticRenderFns } from "./wtTranscriptButton.vue?vue&type=template&id=21ce892c&scoped=true&"
import script from "./wtTranscriptButton.vue?vue&type=script&lang=js&"
export * from "./wtTranscriptButton.vue?vue&type=script&lang=js&"
import style0 from "./wtTranscriptButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wtTranscriptButton.vue?vue&type=style&index=1&id=21ce892c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce892c",
  null
  
)

export default component.exports